import { render, staticRenderFns } from "./Warehouse_quantity.vue?vue&type=template&id=215ea1fb&scoped=true&"
import script from "./Warehouse_quantity.vue?vue&type=script&lang=js&"
export * from "./Warehouse_quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ea1fb",
  null
  
)

export default component.exports